<template>
  <div class="mainx">
    <BaseHeader :title="$t('views.seller.reports.text_1428')"></BaseHeader>
    <b-breadcrumb :items="[{ text: 'Dashboard', href: 'dashboard' }, { text: $t('views.seller.reports.text_1428') }]"
      class="bg-white m-0 p-0"></b-breadcrumb>
    <div class="divider"></div>
    <div>
      <FilterExport />
      <div class="container-reports">
        <div class="reports-row">
          <Container title="Faturamento">
            <Revenues :filter="filter" :data="revenues" />
          </Container>
        </div>

        <div class="reports-row">
          <!-- Liberação de saldo diário -->
          <Container :cols="6" title="Liberação de saldo diário"
            subtitle="Previsões de valores disponíveis para saque, dia a dia. Sujeito a alteração por chargebacks e reembolsos."
            link="/relatorios/liberacao_saldo">
            <div class="balance-predict-row">
              <BigNumber :title="`${today} - Hoje`"
                :value="balancePredictions && balancePredictions['sales_grouped_by_date'][todayDate] ? balancePredictions['sales_grouped_by_date'][todayDate]['Valor a liberar'] : 'R$ 0,00'"
                size="lg" />
              <BigNumber :title="`${tomorrow} - Amanhã`"
                :value="balancePredictions && balancePredictions['sales_grouped_by_date'][tomorrowDate] ? balancePredictions['sales_grouped_by_date'][tomorrowDate]['Valor a liberar'] : 'R$ 0,00'"
                :border="true" size="lg" />
            </div>
          </Container>
          <Container :cols="6" :title="$t('views.seller.reports.text_1444')"
            :subtitle="$t('views.seller.reports.text_1449')"
            link="/relatorios/potencial_receita">
            <div class="balance-predict-row">
              <BigNumber :title="`${nextMonth}`"
                :value="balancePredictions && balancePredictions['sales_grouped_by_month'][nextMonthDate] ? balancePredictions['sales_grouped_by_month'][nextMonthDate]['total_label'] : 'R$ 0,00'"
                size="lg" />
              <BigNumber :title="`${secondMonth}`"
                :value="balancePredictions && balancePredictions['sales_grouped_by_month'][secondMonthDate] ? balancePredictions['sales_grouped_by_month'][secondMonthDate]['total_label'] : 'R$ 0,00'"
                :border="true" size="lg" />
            </div>
          </Container>
        </div>

        <div class="reports-row">
          <!-- Status de vendas únicas -->
          <Container :cols="4" title="Status de vendas únicas"
            subtitle="Status de vendas que não contemplam assinaturas.">
            <DoughnutData subtitle="Vendas únicas"
              :labels="salesData ? Object.keys(salesData['salesTransactionByStatus']) : []"
              :data="salesData ? Object.values(salesData['salesTransactionByStatus']) : []" />
          </Container>

          <!-- Meus Contratos (antes: Status de vendas de assinaturas) -->
          <Container :cols="4" title="Meus Contratos"
            subtitle="Status de vendas recorrentes, com cobranças por período de tempo."
            :link="'/contratos'">
            <template v-if="salesData && salesData['salesSubscriptionByStatus']">            
              <DoughnutData subtitle="Contratos"
                :labels="Object.keys(salesData['salesSubscriptionByStatus'])"
                :data="Object.values(salesData['salesSubscriptionByStatus'])" />
            </template>
            <template v-else>
              <DoughnutData subtitle="Contratos" :labels="[]" :data="[]" />
            </template>
          </Container>

          <!-- Tipos de receita -->
          <Container :cols="4" title="Tipos de receita"
            subtitle="Quantidade de vendas e porcentagem correspondente de cada tipo de transação.">
            <div class="row">
              <div class="col-6 d-flex flex-column" style="gap: 24px">
                <BigNumber title="Venda única" :value="getSalesPercentage('salesByType', 'transaction')"
                  :subtitle="getSalesTotal('salesByType', 'transaction')" size="md">
                  <template v-slot:tooltip>
                    <InfoTooltip label="Vendas que não contemplam assinaturas." />
                  </template>
                </BigNumber>
                <BigNumber title="Order bump" :value="getSalesPercentage('salesByType', 'bump')"
                  :subtitle="getSalesTotal('salesByType', 'bump')" size="md">
                  <template v-slot:tooltip>
                    <InfoTooltip label="Vendas complementares de produtos no checkout." />
                  </template>
                </BigNumber>
              </div>
              <div class="col-6 d-flex flex-column" style="gap: 24px">
                <BigNumber title="Assinatura" :value="getSalesPercentage('salesByType', 'subscription')"
                  :subtitle="getSalesTotal('salesByType', 'subscription')" size="md">
                  <template v-slot:tooltip>
                    <InfoTooltip
                      label="Cobranças recorrentes por período de tempo. Mensal, trimestral, semestral e anual." />
                  </template>
                </BigNumber>
                <BigNumber title="Upsell" :value="getSalesPercentage('salesByType', 'upsell')"
                  :subtitle="getSalesTotal('salesByType', 'upsell')" size="md">
                  <template v-slot:tooltip>
                    <InfoTooltip label="Vendas complementares de produtos após checkout." />
                  </template>
                </BigNumber>
              </div>
            </div>
          </Container>
        </div>

        <div class="reports-row">

          <!-- Métodos de pagamento -->
          <Container :cols="4" title="Métodos de pagamento"
            subtitle="Quantidade de vendas considerando todos os meios de pagamento disponíveis.">
            <DoughnutData subtitle="Vendas" :labels="salesData ? Object.keys(salesData['salesByMethod']) : []"
              :data="salesData ? Object.values(salesData['salesByMethod']) : []" />
          </Container>

          <!-- Novo Style Two Columns -->
          <Container :cols="8" link="/relatorios/recusas_cc">
            <div class="d-flex flex-row" style="gap: 20px; height: 100%; position: relative; margin-top: -25px;">
            
              <div class="d-flex flex-column" style="flex: 1">
              
                <Container :cols="12" title="Recusas do cartão de crédito"
                  subtitle="Motivos que o cartão de crédito dos usuários recusou as compras dos seus produtos únicos e de assinaturas."
                  :useContainer="false">
                  <DoughnutData subtitle="Recusadas " :labels="salesData ? Object.keys(salesData['salesRefused']) : []"
                    :data="salesData ? Object.values(salesData['salesRefused']) : []" />
                </Container>

              </div>
           
              <div class="d-flex flex-column" style="width: 1px">
                <div class="vertical-line" style="height: 100%; border: 1px solid #D7DAE2;"></div>
              </div>
          
              <div class="d-flex flex-column " style="flex: 1;">
               
                <Container :cols="12" title="Taxa de aprovação Voomp"
                  subtitle="Porcentagem de aceitação do cartão de crédito nas instituições financeiras, considerando recusas Voomp."
                  :useContainer="false">
                  <div class="rate-percentage-value">
                    <BigNumber title="Cartão de crédito" :value="approvalRate"
                      size="md" />
                  </div>
                </Container>
              </div>
            </div>
          </Container>
        </div>

        <div class="reports-row">

          <!-- Ofertas mais vendidas -->
          <Container :cols="4" title="Ofertas mais vendidas" subtitle="Seus produtos mais vendidos.">
            <List :data="salesData ? salesData['salesByOffer'] : []" />
          </Container>

          <!-- Melhores afiliados -->
          <Container :cols="4" title="Melhores afiliados"
            subtitle="Lista dos seus afiliados com maior número de vendas." :fullWidth="true">
            <Table :filter="filter" :columns="['Nome afiliado', 'Vendas pagas', 'Comissão recebida']"
              :rows="salesUsersPerformance ? Object.values(salesUsersPerformance['affiliates']) : []" />
          </Container>

          <!-- Melhores coprodutores -->
          <Container :cols="4" title="Melhores coprodutores"
            subtitle="Lista dos seus coprodutores com maior número de vendas." :fullWidth="true">
            <Table :filter="filter" :columns="['Nome coprodutor', 'Vendas pagas', 'Comissão recebida']"
              :rows="salesUsersPerformance ? Object.values(salesUsersPerformance['cosellers']) : []" />
          </Container>
        </div>

        <div class="reports-row" style="max-height: 400px;">

          <!-- Origem das vendas -->
          <Container :cols="8" title="Origem das vendas"
            subtitle="Lista das tags/parâmetros com maior número de vendas." :fullWidth="true">
            <Table :filter="filter" :columns="['Tags', 'Tipo de origem', 'Quantidade de vendas', 'Valor total']"
              :rows="salesMetaTags ? salesMetaTags : []" />
          </Container>

          <!-- Taxa de conversão -->
          <Container :cols="4" title="Taxa de conversão"
            subtitle="Quantidade de vendas e porcentagens finalizadas com sucesso em cada meio de pagamento disponível.">
            <div class="row">
              <div class="col-6 d-flex flex-column" style="gap: 24px">
                <BigNumber title="Cartão de crédito" :value="getSalesPercentage('salesByMethod', 'CREDIT_CARD')"
                  :subtitle="getSalesTotal('salesByMethod', 'CREDIT_CARD')" size="md" />
                <BigNumber title="Pix" :value="getSalesPercentage('salesByMethod', 'PIX')"
                  :subtitle="getSalesTotal('salesByMethod', 'PIX')" size="md" />
              </div>
              <div class="col-6 d-flex flex-column" style="gap: 24px">
                <BigNumber title="Paypal" :value="getSalesPercentage('salesByMethod', 'PAYPAL')"
                  :subtitle="getSalesTotal('salesByMethod', 'PAYPAL')" size="md" />
                <BigNumber title="Boleto" :value="getSalesPercentage('salesByMethod', 'BOLETO')"
                  :subtitle="getSalesTotal('salesByMethod', 'BOLETO')" size="md" />
              </div>
            </div>
          </Container>
          <!-- <Container title="Resumo do checkout" :cols="4">
            <Checkout :filter="filter" />
          </Container> -->
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import Container from "@/components/Seller/Reports/Container.vue";
import Moment from "moment-timezone";
import Checkout from "@/components/Seller/Reports/Checkout.vue";
import Revenues from "@/components/Seller/Reports/Revenues.vue";
import Table from "@/components/Seller/Reports/Table.vue";
import BigNumber from "@/components/Seller/Reports/BigNumber.vue";
import DoughnutData from "@/components/Seller/Reports/DoughnutData.vue";
import List from "@/components/Seller/Reports/List.vue";
import InfoTooltip from "@/components/Seller/Reports/InfoTooltip.vue";

import Contracts from "@/components/Seller/Reports/Contracts.vue";

import ReportService from "@/services/resources/ReportService";
import FilterExport from './FilterExport.vue'

const Report = ReportService.build();
const moment = Moment;

export default {
  name: "Reports",
  components: {
    Checkout,
    Container,
    Contracts,
    Revenues,
    Table,
    BigNumber,
    DoughnutData,
    List,
    InfoTooltip,
    FilterExport
  },
  data: () => {
    return {
      today: moment().format("DD/MM/YYYY"),
      todayDate: moment().format("YYYY-MM-DD"),
      tomorrow: moment().add(1, "days").format("DD/MM/YYYY"),
      tomorrowDate: moment().add(1, "days").format("YYYY-MM-DD"),
      nextMonth: moment().add(1, "months").locale('pt-br').format("MMMM \\d\\e YYYY"),
      nextMonthDate: moment().add(1, "months").format("YYYY-MM"),
      secondMonth: moment().add(2, "months").locale('pt-br').format("MMMM \\d\\e YYYY"),
      secondMonthDate: moment().add(2, "months").format("YYYY-MM"),

      loading: false,

      salesData: null,
      balancePredictions: null,
      revenues: null,
      salesUsersPerformance: null,
      salesMetaTags: [],
      percentageRefunded: null,
    };
  },
  computed: {
    filter() {
      return this.$store.getters.getFilters;
    },
    creditCardApprovalRate() {
      return this.salesData &&
        this.salesData.salesRefused &&
        this.salesData.salesRefused.CREDIT_CARD ?
        this.salesData.salesRefused.CREDIT_CARD.percentage :
        '0,00%';
    },
    percentageRefundedData() {
      if (!this.salesData || !this.salesData.percentageRefunded) {
        return {
          total_sales_card: '0a',
          percented_value: '0b%',
          total_sales_refunded: '0c'
        }
      }
      return this.salesData.percentageRefunded;
    },
    approvalRate() {
      return this.percentageRefunded ? this.percentageRefunded.approval_rate : '0%';
    }
  },
  methods: {
    getSalesPercentage(dataKey, method) {
      return this.salesData && this.salesData[dataKey] && this.salesData[dataKey][method]
        ? this.salesData[dataKey][method]['percentage'] + '%'
        : '0,00%';
    },
    getSalesTotal(dataKey, method) {
      return this.salesData && this.salesData[dataKey] && this.salesData[dataKey][method]
        ? this.salesData[dataKey][method]['info']
        : '0 vendas';
    },
    fetchReport() {
      this.loading = true;
      let filters = {
          products: [],
          startDate: moment.tz('America/Sao_Paulo').subtract(12, 'months').format('YYYY-MM-DD'),
          endDate: moment.tz('America/Sao_Paulo').add(2, 'months').endOf('month').format('YYYY-MM-DD'),
          monthYear: '',
          creditCard: '',
          boleto: '',
          international: '',
          grossValue: '',
          salesQtd: ''
        };
      Report.search({ url: "upcoming-invoices", ...filters, type: "summary" })
        .then((response) => {
          this.balancePredictions = response;
        })
        .catch((e) => {
          this.loading = false;
        });

      Report.search({ url: "revenues", ...this.filter })
        .then((response) => {
          this.revenues = response;
        })
        .catch((e) => {
          this.loading = false;
        });

      Report.search({ url: "sales-data", ...this.filter })
        .then((response) => {
          this.salesData = response;
          this.percentageRefunded = response.percentageRefunded;
          this.$store.commit('setSubscriptionStatus', response.salesSubscriptionByStatus);
          return;
        })
        .catch((e) => {
          return;
          this.loading = false;
        });

      Report.search({ url: "sales-users-performance", ...this.filter })
        .then((response) => {
          this.salesUsersPerformance = response;
        })
        .catch((e) => {
          this.loading = false;
        });

      Report.search({ url: "sales-meta-tags", ...this.filter })
        .then((response) => {
          this.loading = false;
          this.salesMetaTags = response;
        })
        .catch((e) => {
          this.loading = false;
        });

    },
  },

};
</script>

<style scoped>
.reports-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.container-reports {
  margin-top: 25px;
  gap: 24px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-bottom: 24px;
}

.balance-predict-row {
  display: flex;
  justify-content: space-between;
  max-width: 500px;
}

.rate-sub-title {
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #6B7280;
}

.rate-pecentage-value {
  font-family: Inter;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0%;
  color: #111827;
}

.rate-sales-value {
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0%;
  color: #111827;
}
</style>